import React, { useEffect, useState } from 'react';
import './styles/UpgradeModal.css';
import {
  fetchPublicPlans,
  findPlan,
  formatAccountsLabel,
  formatApiKeysLabel,
  formatPlanPrice,
  formatRetentionLabel,
  primaryFeatureSummary,
} from '../lib/planCatalog';

export default function UpgradeModal({ isOpen, onClose, feature }) {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    if (!isOpen) return undefined;

    let active = true;
    fetchPublicPlans()
      .then((nextPlans) => {
        if (active) setPlans(nextPlans);
      })
      .catch(() => {
        if (active) setPlans([]);
      });

    return () => {
      active = false;
    };
  }, [isOpen]);

  const featureNames = {
    pdf_export: 'PDF Reports',
    broker_comparison: 'Broker Comparison',
    monte_carlo: 'Monte Carlo Simulation',
    unlimited_accounts: 'Unlimited Accounts',
    unlimited_retention: 'Unlimited Data Retention',
  };

  const featureName = featureNames[feature] || 'This Feature';
  const freePlan = findPlan(plans, 'free');
  const proPlan = findPlan(plans, 'pro');
  const freeFeatures = [
    formatAccountsLabel(freePlan),
    formatApiKeysLabel(freePlan),
    formatRetentionLabel(freePlan),
    primaryFeatureSummary(freePlan),
    'CSV export',
  ];
  const proFeatures = [
    formatAccountsLabel(proPlan),
    formatApiKeysLabel(proPlan),
    formatRetentionLabel(proPlan),
    primaryFeatureSummary(proPlan),
    'CSV + PDF export',
    'Priority support',
  ];

  if (!isOpen) return null;

  return (
    <div className="upgrade-modal-overlay" onClick={onClose}>
      <div className="upgrade-modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="upgrade-modal-close" onClick={onClose}>x</button>

        <div className="upgrade-modal-header">
          <h2>Upgrade to PRO</h2>
          <p className="upgrade-modal-subtitle">Unlock <strong>{featureName}</strong> and more</p>
        </div>

        <div className="upgrade-modal-content">
          <div className="upgrade-comparison">
            <div className="plan-card free-plan">
              <h3>FREE</h3>
              <p className="price">
                {freePlan ? '$0' : 'Plan'}
                <span>{freePlan ? '/forever' : ' details loading'}</span>
              </p>
              <ul className="features-list">
                {freeFeatures.map((item) => (
                  <li key={item}>- {item}</li>
                ))}
              </ul>
            </div>

            <div className="plan-card pro-plan">
              <div className="pro-badge">MOST POPULAR</div>
              <h3>PRO</h3>
              <p className="price">
                {proPlan ? formatPlanPrice(proPlan)?.replace('/month', '') : 'Plan'}
                <span>{proPlan ? '/month' : ' details loading'}</span>
              </p>
              <ul className="features-list">
                {proFeatures.map((item) => (
                  <li key={item}>- {item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="upgrade-modal-footer">
          <button className="btn-secondary" onClick={onClose}>Not Now</button>
          <a href="https://trackmyfxea.com/pricing" target="_blank" rel="noopener noreferrer" className="btn-primary">
            Upgrade to PRO
          </a>
        </div>
      </div>
    </div>
  );
}
